/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit AutocompleteAddress.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import AutocompleteAddressChoice from 'DesignSystem/AutocompleteAddressChoice/logic.js'
import InputSmallLabel from 'DesignSystem/InputSmallLabel/view.js'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react.js'
import { css } from "emotion"
AutocompleteAddressChoice.displayName = 'AutocompleteAddressChoiceLogic'

let styles = {}
styles.AutocompletePopup = css({label: 'AutocompletePopup',
  backgroundColor: "#ff2424"})
styles.List = css({label: 'List',
  backgroundColor: "#ffffff",
borderBottomLeftRadius: 5,
borderBottomRightRadius: 5,
borderTopLeftRadius: 5,
borderTopRightRadius: 5,
left: 0,
paddingBottom: 4,
paddingLeft: 4,
paddingRight: 4,
position: "absolute",
boxShadow: "0px 4px 20px 0px rgba(109, 109, 109, 0.2)",
top: 5,
zIndex: 1,
width: 500})

export default function AutocompleteAddress({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  onBlur,
onChange,
onSubmit,
placeholder= "Address",
value,
isInvalid,
label,
width= 300,
marginRight= 8,
isShowingSuggestions,
from,
chooseAddress,
selected,
prevSuggestion,
nextSuggestion,
chooseSelectedAddress,
closeSuggestions
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="AutocompleteAddress.AutocompleteAddress:1"
 data-view-path={dataViewPath}
 className="views-block"
>
<InputSmallLabel
 data-testid="AutocompleteAddress.InputSmallLabel"
 data-view-path={dataViewPath}
 autoComplete="off"
 className="mousetrap"
 onBlur={onBlur}
 onChange={onChange}
 onSubmit={onSubmit}
 placeholder={placeholder}
 type="text"
 value={value}
 isInvalid={isInvalid}
 label={label}
 width={width}
 marginRight={marginRight}
 className="mousetrap"
/>
{
isShowingSuggestions ? 
<div
 data-testid="AutocompleteAddress.AutocompletePopup"
 data-view-path={dataViewPath}
 className={`views-block ${styles.AutocompletePopup}`}
>
<div
 data-testid="AutocompleteAddress.List"
 data-view-path={dataViewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(from) && from.map((item, index, list) => 
<AutocompleteAddressChoice
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 key={item.id || index}
 data-testid="AutocompleteAddress.AutocompleteAddressChoice"
 onClick={chooseAddress}
 selected={selected}
/>
)}
</div>
<Shortcut
 data-testid="AutocompleteAddress.Shortcut"
 data-view-path={dataViewPath}
 keys="up"
 onPress={prevSuggestion}
/>
<Shortcut
 data-testid="AutocompleteAddress.Shortcut:1"
 data-view-path={dataViewPath}
 keys="down"
 onPress={nextSuggestion}
/>
<Shortcut
 data-testid="AutocompleteAddress.Shortcut:2"
 data-view-path={dataViewPath}
 keys="enter"
 onPress={chooseSelectedAddress}
/>
<Shortcut
 data-testid="AutocompleteAddress.Shortcut:3"
 data-view-path={dataViewPath}
 keys="esc"
 onPress={closeSuggestions}
/>
</div>
 : null
}
</div>
{children}
</React.Fragment>)
}